var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchlet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.8305 0C26.5254 0 13.3051 0 0 0C0 13.2777 0 26.6388 0 40C13.3898 40 26.6102 40 39.9153 40C39.9153 39.4155 40 38.9144 40 38.4134C40 26.1378 40 13.8622 40 1.50313C40 1.00209 39.9153 0.501044 39.8305 0ZM33.1356 11.1065C33.1356 14.1962 33.1356 14.1962 30.1695 15.2818C24.5763 17.286 19.661 20.2923 16.6102 25.3862C15.4237 27.3069 14.7458 29.5616 14.0678 31.7328C13.7288 32.9019 13.2203 33.4029 11.9492 33.4864C6.94915 33.904 6.44068 31.5658 8.22034 28.0585C11.6102 21.4614 16.0169 15.6159 22.3729 11.4405C24.7458 9.85386 27.5424 8.85177 30.339 7.93319C32.7119 7.18163 33.2203 7.68267 33.2203 10.1879C33.1356 10.5219 33.1356 10.8559 33.1356 11.1065Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchlet);
export default __webpack_public_path__ + "static/media/Archlet.1a76699b88bc7bd6ed33bf70fe805a0e.svg";
export { ForwardRef as ReactComponent };